import React from 'react';
import PropTypes from 'prop-types';
import {
  withRouter,
} from 'react-router-dom';

import AppWrapper from './appWrapper';

const App = ({
  children,
}) => {
  return (
    <AppWrapper>
      {children}
    </AppWrapper>
  );
};

App.propTypes = {
  children: PropTypes.object,
};

export default withRouter(App);
